var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.238 16.806c3.517 3.49 9.04 3.726 12.83.722.542-.395.791-.667 1.428-1.397l.034-.033a9.686 9.686 0 0 0-.647-13.033c-3.793-3.768-9.926-3.746-13.69.05-3.767 3.793-3.747 9.923.045 13.69ZM4.91 4.82c2.824-2.845 7.422-2.864 10.264-.037A7.26 7.26 0 1 1 4.943 15.086a7.257 7.257 0 0 1-.032-10.265Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.143 21.684-2.594 2.594-7.2-7.2 2.594-2.594 7.2 7.2M9.357 5.896v3.271H5.895v1.538h3.462v3.269h1.458v-3.269h3.412V9.167h-3.412v-3.27H9.357"
  })));
};
export default SvgZoomIn;